function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Icon, Button } from '@unite-us/ui';
import classNames from 'classnames';
import getNeedIcon from './utils';
import { APP_ENVIRONMENT, CALLBACKS } from '../../api/config';
import './RiskDisplay.scss';
import NeedsList from './components/NeedsList';
function RiskDisplay(_ref) {
  var _selectedNeed$service;
  var needs = _ref.needs,
    isSaving = _ref.isSaving,
    contactId = _ref.contactId,
    personName = _ref.personName,
    submissionId = _ref.submissionId;
  var pushInHistory = CALLBACKS.pushInHistory;
  var isEmr = APP_ENVIRONMENT.isEmr;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    clientsNeeds = _useState2[0],
    setClientsNeeds = _useState2[1];
  var _useState3 = useState(undefined),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedNeed = _useState4[0],
    setSelectedNeed = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    selectedServices = _useState6[0],
    setSelectedServices = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    openNeedsList = _useState8[0],
    setOpenNeedsList = _useState8[1];
  var onCreateReferrals = function onCreateReferrals() {
    var needIds = selectedServices.map(function (service) {
      return service.id;
    });
    var needsIdFormatted = needIds.join(',');
    var path = "/referrals/create/add-resources?person=".concat(contactId, "&services=").concat(needsIdFormatted, "&screening=").concat(submissionId);
    pushInHistory(path);
  };
  var getNeeds = function getNeeds(needs) {
    var needsArray = [];
    for (var key in needs) {
      needsArray.push(_objectSpread(_objectSpread({}, needs[key]), {}, {
        name: key
      }));
    }
    return needsArray;
  };
  useEffect(function () {
    var needsArray = getNeeds(needs);
    var servicesToAdd = [];
    needsArray.forEach(function (need) {
      var services = need.services_subtypes.map(function (service) {
        return {
          code: service.code,
          service: service.name,
          need: service.identified_need,
          id: service.id
        };
      });
      servicesToAdd = servicesToAdd.concat(services);
    });
    setClientsNeeds(needsArray);
    // set one by default to display
    if (needsArray.length > 0) {
      setSelectedNeed(needsArray[0]);
      setSelectedServices(servicesToAdd);
    }
  }, [needs]);
  var handleChangeNeed = function handleChangeNeed(need) {
    setSelectedNeed(need);
  };
  if (clientsNeeds && clientsNeeds.length === 0) {
    return /*#__PURE__*/React.createElement("div", {
      className: "risk-display__no-needs"
    }, /*#__PURE__*/React.createElement("h3", null, "No needs were identified for your client."));
  }
  var handleServiceClicked = function handleServiceClicked(service) {
    var serviceIndex = selectedServices.findIndex(function (selectedService) {
      return selectedService.code === service.code;
    });
    if (serviceIndex > -1) {
      var services = _toConsumableArray(selectedServices);
      services.splice(serviceIndex, 1);
      setSelectedServices(services);
    } else {
      setSelectedServices([].concat(_toConsumableArray(selectedServices), [{
        code: service.code,
        service: service.name,
        need: service.identified_need
      }]));
    }
  };
  var handleSelectAll = function handleSelectAll(selectedNeed) {
    var servicesToAdd = _toConsumableArray(selectedServices);
    selectedNeed === null || selectedNeed === void 0 || selectedNeed.services_subtypes.forEach(function (service) {
      var serviceIndex = selectedServices.findIndex(function (selectedService) {
        return selectedService.code === service.code;
      });
      if (serviceIndex === -1) {
        servicesToAdd.push({
          code: service.code,
          service: service.name,
          need: service.identified_need
        });
      }
      servicesToAdd.length > 0 && setSelectedServices(servicesToAdd);
    });
  };
  var needsToDisplay = clientsNeeds && clientsNeeds.slice(0, 5) || [];
  var clientsNeedsAmount = clientsNeeds && clientsNeeds.length || 0;
  var header = /*#__PURE__*/React.createElement("div", {
    className: "header-text"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "header-text__title"
  }, clientsNeedsAmount, ' ', "Identified", ' ', clientsNeedsAmount > 1 ? 'Needs' : 'Need'), /*#__PURE__*/React.createElement("p", {
    className: "header-text__description"
  }, "The screening has identified the following areas in which", ' ', personName || 'the client', ' ', "could use assistance. Select the services that would best address client\u2019s situation and search for providers in the next step."));
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('risk-display', {
      'emr-risk-padding': isEmr
    })
  }, header, /*#__PURE__*/React.createElement("div", {
    className: classNames('displayed-needs', {
      'emr-gap': isEmr
    })
  }, clientsNeedsAmount > 1 && needsToDisplay.map(function (need) {
    var selected = selectedServices.filter(function (service) {
      return service.need === need.name;
    }) || [];
    var icon = getNeedIcon(need.name);
    return /*#__PURE__*/React.createElement("button", {
      className: classNames('need-card', {
        'need-card--active': selectedNeed && selectedNeed.name === need.name,
        'need-card--web-app': !isEmr,
        'need-card--emr': isEmr
      }),
      type: "button",
      key: need.name,
      onClick: function onClick() {
        return handleChangeNeed(need);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: icon,
      className: "fill-current text-brand-blue",
      size: 24
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between w-full"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pl-3"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "need-card__name"
    }, need.name.replace('_', ' ')), /*#__PURE__*/React.createElement("p", {
      className: "need-card__n-selected"
    }, selected.length, ' ', "selected")), need.name === 'interpersonal_safety' && /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col items-center"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "need-card__name"
    }, need.risk_score || 0), /*#__PURE__*/React.createElement("p", {
      className: "need-card__risk"
    }, "Risk"))));
  }), clientsNeedsAmount > 5 && /*#__PURE__*/React.createElement("button", {
    className: "need-card",
    key: "allNeeds",
    onClick: function onClick() {
      return setOpenNeedsList(true);
    },
    type: "button"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pl-3"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "need-card__name need-card__name--extra"
  }, "See all", ' ', clientsNeeds.length, ' ', "needs")))), selectedNeed && /*#__PURE__*/React.createElement("div", {
    className: classNames('detail-need-card', {
      'detail-need-card--white-card': clientsNeedsAmount === 1
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-title"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-title__name"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: getNeedIcon(selectedNeed.name),
    className: "fill-current text-brand-blue",
    size: 24
  }), /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, selectedNeed.name.replace('_', ' ') || '')), /*#__PURE__*/React.createElement("a", {
    className: "select-btn",
    href: "#",
    onClick: function onClick() {
      return handleSelectAll(selectedNeed);
    }
  }, "Select All")), /*#__PURE__*/React.createElement("div", {
    className: "checkbox-list"
  }, (_selectedNeed$service = selectedNeed.services_subtypes) === null || _selectedNeed$service === void 0 ? void 0 : _selectedNeed$service.map(function (service) {
    return /*#__PURE__*/React.createElement("div", {
      key: service.code,
      className: "checkbox-container"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: "checkbox-icon",
      onChange: function onChange() {
        return handleServiceClicked(service);
      },
      checked: selectedServices.some(function (x) {
        return x.code === service.code;
      })
    }), /*#__PURE__*/React.createElement("span", {
      className: "label"
    }, service.name));
  }))), /*#__PURE__*/React.createElement(Button, {
    disabled: isSaving || (selectedServices === null || selectedServices === void 0 ? void 0 : selectedServices.length) === 0,
    fullWidth: true,
    id: "screening-need-selector-submit-button",
    label: "Search for Resources",
    onClick: onCreateReferrals,
    primary: true
  }), /*#__PURE__*/React.createElement(NeedsList, {
    isSaving: isSaving,
    open: openNeedsList,
    setOpenNeedsList: setOpenNeedsList,
    isSupersetEnabled: true,
    handleSubmit: onCreateReferrals,
    clientsNeeds: clientsNeeds,
    header: header,
    selectedServices: selectedServices,
    handleServiceClicked: handleServiceClicked,
    handleSelectAll: handleSelectAll
  }));
}
RiskDisplay.propTypes = {
  screening: PropTypes.shape({
    contact: PropTypes.object,
    id: PropTypes.string,
    needs: PropTypes.array,
    risk_level: PropTypes.string
  }),
  isCaseManager: PropTypes.bool.isRequired
};
RiskDisplay.defaultProps = {
  screening: {}
};
export default RiskDisplay;
//# sourceMappingURL=index.js.map